import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService';

export default function useGoogleMaps() {
  return usePlacesService({ apiKey: process.env.GOOGLE_MAPS_API_KEY, options: { types: ['address'] } });
}
